export function buildHeroBackgroundStyle(media = {}, cacheBust = null, fallbackImage = '') {
	const raw = media?.heroImageUrl || ''
	let url = raw || fallbackImage

	if (raw && !raw.startsWith('data:') && cacheBust) {
		const sep = raw.includes('?') ? '&' : '?'
		url = `${raw}${sep}t=${cacheBust}`
	}

	const overlayColor = media?.overlayColor ?? null
	const overlayOpacity = media?.overlayOpacity ?? null
	let backgroundImage = `url(${url})`

	if (overlayColor && overlayOpacity !== null) {
		const r = parseInt(overlayColor.slice(1, 3), 16)
		const g = parseInt(overlayColor.slice(3, 5), 16)
		const b = parseInt(overlayColor.slice(5, 7), 16)
		const overlay = `rgba(${r}, ${g}, ${b}, ${overlayOpacity / 100})`
		backgroundImage = `linear-gradient(${overlay}, ${overlay}), url(${url})`
	}

	return {
		backgroundImage,
		backgroundSize: 'cover',
		backgroundPosition: 'center',
	}
}